import type { ExtendedColumnDef, Filter } from '../types';
import { BaseSelectColumnFilter } from './BaseSelectColumnFilter';

const NumberSelectColumnFilter: Filter = (props) => (
  <BaseSelectColumnFilter
    {...props}
    compareValues={(a, b) => Number(a) - Number(b)}
  />
);

export const numberSelectColumnFilter = {
  Filter: NumberSelectColumnFilter,
  filterFn: 'equals',
} as const satisfies Pick<ExtendedColumnDef<any>, 'Filter' | 'filterFn'>;
